import React, { useEffect } from 'react';
import logo from '../../assets/images/logo-light.png';
import StickyMenu from '../../lib/StickyMenu';
import Navigation from '../Navigation';
import { Link } from 'react-scroll'; 

function HeaderHomeEight({ action }) {
    useEffect(() => {
        StickyMenu();
    });
    return (
        <>
            <header className="appie-header-area appie-header-8-area appie-sticky">
                <div className="container">
                    <div className="header-nav-box header-nav-box-6">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-4 col-sm-8 col-6 order-1 order-sm-1">
                                <h3 className="appie-logo-heading">Universe <span className="appie-logo-heading-color">Media</span></h3>
                                <h3 className="appie-logo-heading">& <span className="appie-logo-heading-color">Technologies</span></h3>
                                <div className="appie-logo-box">                                   
                                    <a href="/">
                                        <img src={logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-1 col-sm-1 order-3 order-sm-2">
                                <div className="appie-header-main-menu">
                                    <Navigation />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-7 col-sm-6 col-6 order-2 order-sm-3">
                                <div className="appie-btn-box text-right">
                                    <a className="main-btn ml-30" href="mailto:info@universe-media.com">
                                        Book a demo
                                    </a>
                                    {/* <Link className="main-btn ml-30" to="contactus" spy={true} smooth={true} offset={50} duration={500}>Book a demo</Link>
                                    <div
                                        onClick={(e) => action(e)}
                                        className="toggle-btn ml-30 canvas_open d-lg-none d-block"
                                    >
                                        <i className="fa fa-bars" />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderHomeEight;
